import AriaModal from 'react-aria-modal'
import React, { MouseEventHandler, useEffect } from 'react'

interface DialogProps {
  children: any
  className: string
  initialFocus?: string
  onCancel: MouseEventHandler<HTMLButtonElement>
  opened: boolean
  title: string | React.ReactNode
  id?: string
}

const Dialog = ({
  children,
  className,
  initialFocus,
  onCancel,
  opened,
  title,
  id = 'modal-title',
}: DialogProps) => {
  // Manage custom class on html tag to prevent auto-scrolling that would
  // produce an unexpected animation due to default `scroll-behavior: smooth`
  // style
  useEffect(() => {
    if (opened) {
      document.documentElement.classList.add('no-scroll')
      return () => document.documentElement.classList.remove('no-scroll')
    }
  })

  if (!opened) {
    return null
  }

  return (
    <AriaModal
      dialogClass={className}
      getApplicationNode={getApplicationNode}
      includeDefaultStyles={false}
      initialFocus={initialFocus}
      focusDialog={initialFocus === undefined}
      onExit={onCancel}
      titleId={id}
      titleText={title}
      underlayClass='modal-overlay'
      scrollDisabled={true}
      data-testid={id}
    >
      <div role='document' className={`${className}__wrapper`}>
        <button
          type='button'
          className={`${className}-close`}
          onClick={onCancel}
        >
          <span className={`${className}-close__text`}>Fermer</span>
        </button>
        <div className={`${className}__content`}>
          <div
            role='heading'
            aria-level={1}
            id='modal-title'
            className={`${className}-title`}
          >
            {title}
          </div>
          <div id='js-modal-content'>{children}</div>
        </div>
      </div>
    </AriaModal>
  )

  function getApplicationNode() {
    return document.getElementById('js-modal-page')
  }
}

export default Dialog
